import { takeEvery, all, call, put } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import { DELETE_PLAYLISTS, loading, loadPlaylists } from '../../store/ContentPlaylists/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'

export default function* () {
    yield takeEvery(DELETE_PLAYLISTS, worker)
}

function* worker(action) {
    if (action.payload && action.payload[0]) {
        const playlistsIds = action.payload
        try {
            let deletedSuccess = true
            const deleted = yield all(
                playlistsIds.map(playlistId => call(fetchDeletePlaylists, playlistId))
            )

            deleted.map(d => { if (d.error) deletedSuccess = false })

            if (deletedSuccess) {
                yield put(loadPlaylists())
            } else {
                yield put(showAlertError({
                    errors: [`Ошибка сети при ${DELETE_PLAYLISTS}.`, deleted],
                    text: "Не все плейлисты были удалены. Попробуйте заново."
                }))
            }
        }
        catch (e) {
            yield put(showAlertError({
                errors: [`Ошибка сети при ${DELETE_PLAYLISTS}.`, e],
                text: "Не все плейлисты были удалены. Попробуйте заново."
            }))
        }
    }
}

function fetchDeletePlaylists(playlistId) {
    return axios.get(`/playlist/delete?id=${playlistId}`)
        .then(response => response.data)
}